// [DTS-7122] Mapa declarativo dos 7 grupos de despesa do DRE, seus campos e o sinal
// de cada parcela na composição do subtotal. Nomes conferidos 1:1 contra o onSubmit
// (submitForm) de ManutencaoDRE.js -- não deduzir por regex, há plurais irregulares
// (Salario -> vendedor_Salarios, Comissao -> vendedor_Comissoes).

function camposFuncionario(prefixoForm, prefixoIndicador) {
    return [
        { name: `dreFuncionarios_${prefixoForm}_Ferias`, indicadorProp: `${prefixoIndicador}_Ferias`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_INSS`, indicadorProp: `${prefixoIndicador}_INSS`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_FGTS`, indicadorProp: `${prefixoIndicador}_FGTS`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_ImpostoDeRenda`, indicadorProp: `${prefixoIndicador}_ImpostoDeRenda`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_Salario`, indicadorProp: `${prefixoIndicador}_Salarios`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_Comissao`, indicadorProp: `${prefixoIndicador}_Comissoes`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_OutrosPessoal`, indicadorProp: `${prefixoIndicador}_OutrosPessoal`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_DecimoTerceiroSalario`, indicadorProp: `${prefixoIndicador}_DecimoTerceiroSalario`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_VerbaRecisoria`, indicadorProp: `${prefixoIndicador}_VerbaRecisoria`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_ValeAlimentacao`, indicadorProp: `${prefixoIndicador}_ValeAlimentacao`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_ValeRefeicao`, indicadorProp: `${prefixoIndicador}_ValeRefeicao`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_ValeTransporte`, indicadorProp: `${prefixoIndicador}_ValeTransporte`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_ContribuicaoSindical`, indicadorProp: `${prefixoIndicador}_ContribuicaoSindical`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_SeguroDeVida`, indicadorProp: `${prefixoIndicador}_SeguroDeVida`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_PlanoSaude`, indicadorProp: `${prefixoIndicador}_PlanoSaude`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_PlanoOdontologico`, indicadorProp: `${prefixoIndicador}_PlanoOdontologico`, sinal: 1 },
        { name: `dreFuncionarios_${prefixoForm}_IncentivoEstudos`, indicadorProp: `${prefixoIndicador}_IncentivoEstudos`, sinal: 1 },
    ];
}

export const gruposDespesa = [
    {
        key: "vendedores",
        label: "Total Vendedores",
        indicadorEntity: "dreFuncionarios",
        campos: camposFuncionario("Vendedor", "vendedor"),
    },
    {
        key: "gerentes",
        label: "Total Gerentes",
        indicadorEntity: "dreFuncionarios",
        campos: camposFuncionario("Gerente", "gerente"),
    },
    {
        key: "caixa",
        label: "Total Caixa",
        indicadorEntity: "dreFuncionarios",
        campos: camposFuncionario("Caixa", "caixa"),
    },
    {
        key: "administrativo",
        label: "Total Administrativo",
        indicadorEntity: "dreFuncionarios",
        campos: camposFuncionario("Administrativo", "administrativo"),
    },
    {
        key: "ocupacao",
        label: "Total Ocupação",
        // [DTS-7163] Autorizado pelo PO em 02/09/2026: mesmo ícone de ajuda do campo
        // Crédito de PIS/COFINS, também no subtotal do grupo.
        ajuda: "Este subtotal já desconta o Crédito de PIS/COFINS (tratado como subtração), seguindo a mesma regra do Total Despesa Ocupação do Dashboard Consolidado.",
        indicadorEntity: "dreDespesaOcupacionals",
        // Decisão de negócio confirmada (12/08/2026, epico DTS-7077): Crédito de PIS/COFINS
        // SUBTRAI do total, igual ao TotalDespesaOcupacao do DashboardBIService.cs (linha 541).
        campos: [
            { name: "dreDespesaOcupacionals_alugueis", indicadorProp: "alugueis", sinal: 1 },
            { name: "dreDespesaOcupacionals_condominios", indicadorProp: "condominios", sinal: 1 },
            { name: "dreDespesaOcupacionals_fundoPromocao", indicadorProp: "fundoPromocao", sinal: 1 },
            { name: "dreDespesaOcupacionals_AluguelPercentual", indicadorProp: "aluguelPercentual", sinal: 1 },
            { name: "dreDespesaOcupacionals_DecimoTerceiroAluguel", indicadorProp: "decimoTerceiroAluguel", sinal: 1 },
            { name: "dreDespesaOcupacionals_Iptu", indicadorProp: "iptu", sinal: 1 },
            { name: "dreDespesaOcupacionals_CreditoPISCOFINS", indicadorProp: "creditoPISCOFINS", sinal: -1 },
            { name: "dreDespesaOcupacionals_Outras", indicadorProp: "outras", sinal: 1 },
        ],
    },
    {
        key: "estrutural",
        label: "Total Estrutural",
        indicadorEntity: "dreDespesaEstruturals",
        campos: [
            { name: "dreDespesaEstruturals_EnergiaTaxas", indicadorProp: "energiaTaxas", sinal: 1 },
            { name: "dreDespesaEstruturals_SaneamentoBasico", indicadorProp: "saneamentoBasico", sinal: 1 },
            { name: "dreDespesaEstruturals_TelefoniaInternet", indicadorProp: "telefoniaInternet", sinal: 1 },
            { name: "dreDespesaEstruturals_Sistemas", indicadorProp: "sistemas", sinal: 1 },
            { name: "dreDespesaEstruturals_Limpeza", indicadorProp: "limpeza", sinal: 1 },
            { name: "dreDespesaEstruturals_Manutencao", indicadorProp: "manutencao", sinal: 1 },
            { name: "dreDespesaEstruturals_Materiais", indicadorProp: "materiais", sinal: 1 },
            { name: "dreDespesaEstruturals_Eventos", indicadorProp: "eventos", sinal: 1 },
            { name: "dreDespesaEstruturals_SegurancaMonitoramento", indicadorProp: "segurancaMonitoramento", sinal: 1 },
            { name: "dreDespesaEstruturals_ContribuicaoSindical", indicadorProp: "contribuicaoSindical", sinal: 1 },
            { name: "dreDespesaEstruturals_EmpresaTerceirizada", indicadorProp: "empresaTerceirizada", sinal: 1 },
            { name: "dreDespesaEstruturals_Uniformes", indicadorProp: "uniformes", sinal: 1 },
            { name: "dreDespesaEstruturals_RecrutamentoSelecao", indicadorProp: "recrutamentoSelecao", sinal: 1 },
            { name: "dreDespesaEstruturals_ProcessoJudicial", indicadorProp: "processoJudicial", sinal: 1 },
            { name: "dreDespesaEstruturals_DespesaGrafica", indicadorProp: "despesaGrafica", sinal: 1 },
            { name: "dreDespesaEstruturals_FretesCarreto", indicadorProp: "fretesCarreto", sinal: 1 },
            { name: "dreDespesaEstruturals_RepresentacoesViagensTransporte", indicadorProp: "representacoesViagensTransporte", sinal: 1 },
            { name: "dreDespesaEstruturals_IrAluguel", indicadorProp: "irAluguel", sinal: 1 },
            { name: "dreDespesaEstruturals_PerdaRouboBaixaEstoque", indicadorProp: "perdaRouboBaixaEstoque", sinal: 1 },
            { name: "dreDespesaEstruturals_Seguros", indicadorProp: "seguros", sinal: 1 },
            { name: "dreDespesaEstruturals_Outros", indicadorProp: "outros", sinal: 1 },
            { name: "dreDespesaEstruturals_Motoboy", indicadorProp: "motoboy", sinal: 1 },
            { name: "dreDespesaEstruturals_Contabilidade", indicadorProp: "contabilidade", sinal: 1 },
            { name: "dreDespesaEstruturals_Juridico", indicadorProp: "juridico", sinal: 1 },
            { name: "dreDespesaEstruturals_AcoesVendas", indicadorProp: "acoesVendas", sinal: 1 },
        ],
    },
    {
        key: "cartao",
        label: "Total Cartão",
        indicadorEntity: "dreDespesaBancaria",
        campos: [
            { name: "dreDespesaBancaria_TaxaCartaoMDR", indicadorProp: "taxaCartaoMDR", sinal: 1 },
            { name: "dreDespesaBancaria_AluguelMaquina", indicadorProp: "aluguelMaquina", sinal: 1 },
        ],
    },
];

// [DTS-7123] Extraído de SubtotalGrupo.js para ser reaproveitado por TotalDespesas.js
// sem duplicar a regra de sinal/arredondamento/fallback.
export function parseValorCampo(bruto) {
    if (bruto === undefined || bruto === null || bruto === "") return 0;
    const numero = parseFloat(String(bruto).replace(",", "."));
    return isNaN(numero) ? 0 : numero;
}

export function calcularTotalGrupo(grupo, valoresObservados, indicador) {
    return grupo.campos.reduce((acumulado, campo) => {
        const brutoObservado = valoresObservados[campo.name];
        // useWatch retorna undefined até a 1ª interação do usuário (inputs não
        // controlados) -- nesse caso usa o valor vindo da API via `indicador`.
        const valor = brutoObservado === undefined
            ? parseValorCampo(indicador?.[grupo.indicadorEntity]?.[0]?.[campo.indicadorProp])
            : parseValorCampo(brutoObservado);
        return acumulado + valor * campo.sinal;
    }, 0);
}
